module.exports = __webpack_public_path__ + "static/aq-info-249f5ddddcd645c628b29df2dd065fd0.png";